import React, { useEffect } from 'react';
import {
  func,
} from 'prop-types';
import noop from 'lodash/noop';
import { useSelector, useDispatch } from 'react-redux';
import Responsive from '@active/react-utils/components/Responsive';
import Offers from '../../common/Offers';
import PromptMessage from '../../common/information/PromptMessage';
import CouponAndAaCross from './CouponAndAaCross/CouponAndAaCross';
import TransferFee from '../../common/TransferFee';
import Waivers from '../../common/Waivers';
import Payment from '../../common/Payment';
import OrderReviewContainer from './OrderReviewContainer';
import OrderSummaryContainer, { OrderSummaryButtonContainer } from './OrderSummaryContainer';
import OrderReceiptContainer from './OrderReceipContainer';
import { setBillingContactConfig } from '../../common/Payment/components/PaymentMethods/paymentMethodsSlice';
import ShippingAddress from '../../common/passportWidgets/components/ShippingAddress';

const CheckoutView = ({
  trackingCallback, orderReviewActionCallback, handleOrderReviewCallback,
}) => {
  const dispatch = useDispatch();
  const {
    genericPromptMessage, orderLineGroupsMessage,
    orderReceiptAndAccountParams: {
      isShowReceiptAndAccountSection,
    } = {},
    showEmailField,
  } = useSelector(state => state.propsData);

  useEffect(() => {
    dispatch(setBillingContactConfig((isShowReceiptAndAccountSection || !showEmailField) ? [ 'NAME', 'ADDRESS' ] : null));
  }, [ isShowReceiptAndAccountSection, showEmailField, dispatch ]);

  return (
    <React.Fragment>
      <PromptMessage message={genericPromptMessage || orderLineGroupsMessage} />
      <Responsive not eqAbove="xl">
        <OrderSummaryContainer trackingCallback={trackingCallback} className="cui-mg-t-20"/>
      </Responsive>
      <OrderReviewContainer trackingCallback={trackingCallback}
        orderReviewActionCallback={orderReviewActionCallback}
        handleOrderReviewCallback={handleOrderReviewCallback}/>
      <CouponAndAaCross
        trackingCallback={trackingCallback}/>
      <TransferFee
        trackingCallback={trackingCallback}/>
      <Offers/>
      <ShippingAddress />
      <Payment className='cui-mg-t-60' trackingCallback={trackingCallback}/>
      <OrderReceiptContainer />
      <Waivers
        trackingCallback={trackingCallback}/>
      <Responsive not eqAbove="xl">
        <OrderSummaryButtonContainer />
      </Responsive>
    </React.Fragment>
  );
};

CheckoutView.propTypes = {
  trackingCallback: func,
  showLoading: func,
  hideLoading: func,
};

CheckoutView.defaultProps = {
  trackingCallback: noop,
  showLoading: noop,
  hideLoading: noop,
};

export default CheckoutView;
